import DictionaryForm from '@/modules/Dictionary/__form';
import {
  setItemCode,
  setItemName,
} from '@/modules/Dictionary/__form/item';
import FInput from '@/plugins/form/FInput';
import FNumber from '@/plugins/form/FNumber';

export default class DictionaryCabinForm extends DictionaryForm {
  static permission = {
    add: [115],
    edit: [348],
    view: [115],
    remove: [349],
  };

  dictionary = 'cabin';

  constructor(props = {}) {
    super(props);
    setItemName.bind(this)();
    setItemCode.bind(this)();

    this.setItemCategory();
    this.setItemPlaces();
    this.setItemDeck();
    this.setItemAgeFrom();
    this.setItemAgeTo();
  }

  setItemCategory() {
    this.category = new FInput({
      name: 'Category',
      label: 'Категория',
    });
    this.category.setValidatorMax(40);
    this.setItem('category', this.category);
  }

  setItemPlaces() {
    this.places = new FNumber({
      name: 'PlacesCount',
      label: 'Количество мест',
      min: 0,
    });
    this.setItem('places', this.places);
  }

  setItemDeck() {
    this.deck = new FInput({
      name: 'Deck',
      label: 'Палуба',
    });
    this.deck.setValidatorMax(20);
    this.setItem('deck', this.deck);
  }

  setItemAgeFrom() {
    this.ageFrom = new FNumber({
      name: 'AgeFrom',
      label: 'Возраст с',
      min: 0,
    });
    this.setItem('ageFrom', this.ageFrom);
  }

  setItemAgeTo() {
    this.ageTo = new FNumber({
      name: 'AgeTo',
      label: 'Возраст по',
      min: 0,
    });
    this.setItem('ageTo', this.ageTo);
  }
}
